<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-oxt-' + childId"
    data-toggle='collapse'
    :data-target="'#collapse-oxt-' + childId"
    :aria-controls="'collapse-oxt-' + childId"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_1X2", 1) }}
  .collapse.show(
    :aria-labelledby="'heading-oxt-' + childId"
    :id="'collapse-oxt-' + childId"
  )
    .card-body.p-0
      .market-card-content
        .normal(v-if="mode == 0 || mode == 1")
          .normal-title {{ $t("ui.full_time") }}
          .normal-odd-area
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Home") }}
                template(v-if="details['oxt'] && details['oxt'][0] && details['oxt'][0][5] != 0 && details['oxt'][0][5] != ''")
                  OddsItem(:odds="details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" :details="details")
                template(v-else)
                  OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Away") }}
                template(v-if="details['oxt'] && details['oxt'][0] && details['oxt'][0][7] != 0 && details['oxt'][0][7] != ''")
                  OddsItem(:odds="details['oxt'][0]" idx=7 :typ="oddsType" dataType="2" :details="details")
                template(v-else)
                  OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Draw") }}
                template(v-if="details['oxt'] && details['oxt'][0] && details['oxt'][0][6] != 0 && details['oxt'][0][6] != ''")
                  OddsItem(:odds="details['oxt'][0]" idx=6 :typ="oddsType" dataType="2" :details="details")
                template(v-else)
                  OddsDisabled
        .normal(v-if="$helpers.objSize(details['oxth']) > 0 && (mode == 0 || mode == 2)")
          .normal-title {{ $t("ui.half_time") }}
          .normal-odd-area
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Home") }}
                template(v-if="details['oxth'] && details['oxth'][0] && details['oxth'][0][5] != 0 && details['oxth'][0][5] != ''")
                  OddsItem(:odds="details['oxth'][0]" idx=5 :typ="oddsType" dataType="2" :details="details")
                template(v-else)
                  OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Away") }}
                template(v-if="details['oxth'] && details['oxth'][0] && details['oxth'][0][7] != 0 && details['oxth'][0][7] != ''")
                  OddsItem(:odds="details['oxth'][0]" idx=7 :typ="oddsType" dataType="2" :details="details")
                template(v-else)
                  OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Draw") }}
                template(v-if="details['oxth'] && details['oxth'][0] && details['oxth'][0][6] != 0 && details['oxth'][0][6] != ''")
                  OddsItem(:odds="details['oxth'][0]" idx=6 :typ="oddsType" dataType="2" :details="details")
                template(v-else)
                  OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    },
    childId: {
      type: Number
    }
  }
}
</script>